import React from "react";

export const SimpleFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2025 Your Website. All Rights Reserved.</p>
        <ul className="footer-links">
          <li>
            <a href="#1">Privacy Policy</a>
          </li>
          <li>
            <a href="#2">Terms of Service</a>
          </li>
          <li>
            <a href="#3">Contact Us</a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default SimpleFooter;
